module.exports = __webpack_public_path__ + "static/media/icon-info-blue.27ed3142.svg";